/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'countryBaseCodeFilter' }) //, pure:false
export class CountryBaseCodeFilterPipe implements PipeTransform {
    transform(data: any[], searchTerm: string): any[] {
        if (searchTerm) {
            searchTerm = searchTerm.toUpperCase();
            return data.filter(item => {
                return item.name.toUpperCase().includes(searchTerm);
            });
        }
        return data;
    }
}

@Pipe({ name: 'authorFilter' }) //, pure:false
export class AuthorFilterPipe implements PipeTransform {
    transform(data: any[], searchTerm: string): any[] {
        if (searchTerm) {
            searchTerm = searchTerm.toUpperCase();
            return data.filter(item => {
                return item.author.toUpperCase().includes(searchTerm);
            });
        }
        return data;
    }
}

@Pipe({ name: 'reportDateFilter' }) //, pure:false
export class ReportDateFilterPipe implements PipeTransform {
    transform(data: any[], searchTerm: string): any[] {
        if (searchTerm) {
            searchTerm = searchTerm.toUpperCase();
            return data.filter(item => {
                return item.createdDate.toUpperCase().includes(searchTerm);
            });
        }
        return data;
    }
}

@Pipe({ name: 'tagFilter' }) //, pure:false
export class TagFilterPipe implements PipeTransform {
    transform(data: any[], searchTerm: string): any[] {
        if (searchTerm) {
            let filteredItems: any = [], reportTags = [];
            data.forEach(item => {
                reportTags = [];
                reportTags = item.reportTags.filter(function (itemTag: any) {
                    return (itemTag.name == searchTerm);
                })
                if (reportTags.length > 0) {
                    filteredItems.push(item);
                }
            });
            return filteredItems;
        }
        return data;
    }
}